import React from 'react';
import { Header, Footer } from '../Common';
import MenuItemShop from '../../Common/MenuItemShop/MenuItemShop';

/** ABC-SE fallback listing for a header menu item (/clothing/abc-se/shop/:menuItemKey). */
const ABCSEMenuItemShop = () => (
  <MenuItemShop
    brandSlug="abcse"
    feSlug="abc-se"
    dataBrand="ABC"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Paketlösning"
    loadingText="Laddar produkter…"
    emptyTitle="Inga produkter just nu"
    emptyText="Kollektionen kanske uppdateras just nu. Har du frågor hjälper vi gärna till."
    contactLabel="Kontakta oss"
    faqLabel="Se FAQ"
  />
);

export default ABCSEMenuItemShop;
